import Luiv3Constants from '@app/lui3/constants';
import styled from 'styled-components';

export const Title = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${Luiv3Constants.baseColor['gray-1000']};
  line-height: 1.625rem;
`;

export const Subtitle = styled.div`
  font-size: 0.875rem;
  color: ${Luiv3Constants.baseColor['gray-600']};
  line-height: 1.25rem;
  letter-spacing: 0.01em;
`;
